import React from 'react';
import { StyledCircularProgress } from './styles';
import { ProgressCircleProps } from './types';

export const ProgressCircle = (props: ProgressCircleProps) => {
  return <StyledCircularProgress size={props.size || 20} {...props} />;
};
